import { basicAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { domainToRegex } from "../urlPatternConversion";
import logo from "./logo.svg";

export const infoblox = defineConnector({
  identifier: "infoblox",
  name: "Infoblox NIOS",
  tagLine: "On-premises DNS, DHCP, and IPAM",
  logo,
  protocol: "http",
  tags: ["it"],
  defaultUrlPattern: ({ host }) => domainToRegex(host),
  auth: (app) =>
    basicAuth({
      username: app.config.username,
      password: app.secret.password,
    }),
  steps: [
    {
      title: "Prepare your NIOS credentials",
      items: [
        {
          kind: "markdown",
          content:
            "You'll need an administrator account on your Infoblox NIOS appliance with API access enabled. The WAPI uses the same credentials as the Grid Manager UI.",
        },
      ],
    },
    {
      title: "Enter your credentials",
      items: [
        {
          kind: "hostname",
          label: "NIOS host",
          required: true,
          placeholder: "infoblox.example.com",
          helperText: "Your Infoblox NIOS hostname or IP address.",
          target: { kind: "configuration", field: "host" },
        },
        {
          kind: "input",
          label: "Username",
          required: true,
          target: { kind: "configuration", field: "username" },
        },
        {
          kind: "input",
          label: "Password",
          required: true,
          target: { kind: "secrets", field: "password" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ host }) => `https://${host}/wapi/v2.12/grid`,
  },
});
